<template>
    <v-main>
      <MembershipHero/>
      <MembershipEngage/>
      <MembershipOnboarding/>
      <MembershipListen/>
      <MembershipSupport/>
      <RequestDemo msg="Simplify membership management and boost engagement."/>



    </v-main>
</template>
  
<script>
import MembershipHero from './MembershipHero.vue'
import MembershipEngage from './MembershipEngage.vue'
import MembershipOnboarding from './MembershipOnboarding.vue'
import MembershipListen from './MembershipListen.vue'
import MembershipSupport from './MembershipSupport.vue'
import RequestDemo from './RequestDemo.vue'


export default {
  name: 'GovPage',
  components: {
    MembershipHero,
    MembershipEngage,
    MembershipOnboarding,
    MembershipListen,
    MembershipSupport,
    RequestDemo



  },
}
</script>